<template>
    <base-modal v-if="flow === 'A' || flow === 'B'" :controlled="true" :open="true" :unmountAfterMs="1000" :closeable="false">
        <div class="welcome">
            <div>
                <img src="@assets/images/user-onboarding/welcome.png" alt="Welcome" width="100%" />
            </div>
            <div class="text-center my-4">
                <h5 class="font-bold text-xl mb-2 text-darkblue">
                    Chào mừng bạn đến <br />
                    với HyperLead!
                </h5>
                <p class="text-lg font-normal text-darkblue">Hãy để HyperLead hướng dẫn bạn thao tác khởi chạy Affiliate Marketing nhé!</p>
            </div>
            <div>
                <Button class="mb-4 w-full" @click="startOnboarding">Được rồi, đi thôi!</Button>
                <Button class="w-full vs-button--white" color="white" @click="closeOnboarding">Cảm ơn, tôi đã biết sử dụng rồi</Button>
            </div>
        </div>
    </base-modal>
    <div v-else></div>
</template>

<script>
import Button from '../../Button/Button.vue';
import BaseModal from '../../Modal/BaseModal.vue';

export default {
    name: 'welcome-modal',

    components: {
        Button,
        BaseModal,
    },

    props: {
        flow: String,
    },

    data() {
        return {};
    },

    methods: {
        startOnboarding() {
            this.$emit('start');
        },

        closeOnboarding() {
            this.$emit('close');
        },
    },
};
</script>

<style lang="scss"></style>



// WEBPACK FOOTER //
// src/components/UserOnboarding/components/WelcomeModal.vue